import { AfterViewInit, Component, ElementRef, OnDestroy, ViewChild, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { Terminal } from '@xterm/xterm';
import { FitAddon } from '@xterm/addon-fit';
import { AttachAddon } from '@xterm/addon-attach';
import { TeltonikaSshLogInModalComponent } from '../../modals/teltonika-ssh-log-in-modal/teltonika-ssh-log-in-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import {
  DialogService,
  SharedGenericSingletonService,
  SharedTeltonikaSingletonService,
} from '@huge-monorepo/shared/services';
import {
  ICustomerGenericService,
  ICustomerTeltonikaService, IHIPGenericService,
  IHIPTeltonikaService,
} from '@huge-monorepo/shared/interfaces';

@Component({
  selector: 'huge-monorepo-teltonika-device-terminal',
  standalone: true,
  imports: [CommonModule, MaterialModule],
  templateUrl: './teltonika-device-terminal.component.html',
  styleUrl: './teltonika-device-terminal.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class TeltonikaDeviceTerminalComponent implements OnDestroy, AfterViewInit {
  id: number;
  ip: string;
  public term: Terminal;
  socket: WebSocket;
  @ViewChild('myTerminal') terminalDiv: ElementRef;
  dialogSub: Subscription;
  resizeSub: Subscription;
  constructor(
    private route: ActivatedRoute,
    private sharedTeltonikaService: SharedTeltonikaSingletonService<ICustomerTeltonikaService | IHIPTeltonikaService>,
    private dialog: MatDialog,
    private dialogService: DialogService,
    private sharedGenericService: SharedGenericSingletonService<ICustomerGenericService | IHIPGenericService>,
  ) { }

  ngAfterViewInit(): void {

    this.term = new Terminal({
      cursorBlink: true,
      theme: {
        background: '#212121',
        foreground: '#c9c9c9',
      }
    });
    const fitAddon = new FitAddon();

    this.term.loadAddon(fitAddon);
    setTimeout(() => {
      this.term.open(this.terminalDiv.nativeElement);

      fitAddon.fit();
    });
    this.route.paramMap.subscribe(
      (paraMap: any) => {
        if (paraMap.params.id) {
          let id = paraMap.params.id;
          this.id = id;
        }
        if (paraMap.params.ip) {
          this.ip = decodeURIComponent(paraMap.params.ip);
        }
        this.openSSH(this.ip);
      }
    );
  }

  ngOnDestroy(): void {
    if (this.socket) this.socket.close(1000);
    if (this.resizeSub) this.resizeSub.unsubscribe();
    if (this.dialogSub) this.dialogSub.unsubscribe();
    if (this.term) this.term.dispose();
  }

  /**
     * @description Open SSH tunnel
     * @param ip The IP address to open the tunnel to
     */
  openSSH(ip: string) {
    const dialogRef = this.dialog.open(TeltonikaSshLogInModalComponent, {
      width: '800px',
      maxHeight: '60vh',
      data: { address: ip }
    });

    this.dialogService.RegisterDialog(dialogRef);
    this.dialogSub = dialogRef.afterClosed().subscribe((result) => {
      this.dialogService.DeRegisterDialog(dialogRef);
      this.dialogSub.unsubscribe();
      if (result != null && result.username != null && result.password != null) {
        this.startTerminal(ip, result.username, result.password);
      }
    });

  }

  startTerminal(ip: string, username: string, password: string) {

    setTimeout(() => {
      const url: string = this.sharedTeltonikaService.service.getTeltonikaRemoteAccessWebsocketURL(this.id, ip, this.term.rows, this.term.cols, username, password)
      this.socket = new WebSocket(url);

      const attachAddon = new AttachAddon(this.socket);
      this.term.loadAddon(attachAddon);

      this.socket.onmessage = (e: MessageEvent) => {
      };

      this.socket.onerror = (error) => {
        this.socket.close(1000);
      };

      this.socket.onclose = (data) => {
        if (data != null && data.reason != null && data.reason.startsWith("ERR:")) {
          if (data.reason.startsWith("ERR:ssh: handshake failed: ssh: unable to authenticate")) {
            this.sharedGenericService.service.createToast('Error', 'Authentication failed. Please check the username and password and try again.', 'error');
            this.openSSH(ip);
          } else {
            this.term.writeln("Error in Terminal connection: " + data.reason);
          }
        } else {
          this.term.writeln('');
          this.term.writeln(data.reason);
        }

        this.term.writeln('Connection closed');
      };

      this.socket.onopen = () => {

        this.term.writeln(`Attempting to connect with username: ${username}`);

        this.term.onKey((e) => { });
      };

    });
  }
}
